import React, { Component } from "react";
import { UserContext } from "../../Context";
import ProfileFormAddressAdd from "../profileFormAddressAdd/ProfileFormAddressAdd";

import "./profileFormAddresses.css";

import ProfileFormAddressCard from "../profileFormAddressCard/ProfileFormAddressCard";
export default class ProfileFormAddresses extends Component {
  render() {
    return (
      <UserContext.Consumer>
        {userContext => (
          <div className="profile-form-address">
            {userContext.my &&
            userContext.my.addresses &&
            !!Object.keys(userContext.my.addresses)[0] ? (
              Object.keys(userContext.my.addresses)
                .filter((addressId, i) => i === 0)
                .map(addressId => userContext.my.addresses[addressId])
                .map((address, i) => (
                  <ProfileFormAddressCard
                    userContext={userContext}
                    index={1}
                    address={address}
                  />
                ))
            ) : (
              <ProfileFormAddressAdd
                key={`add-address-card-${1}`}
                title={`Current Address`}
                userContext={userContext}
              />
            )}
          </div>
        )}
      </UserContext.Consumer>
    );
  }
}

// {
//   {
//   userContext.my &&
//     userContext.my.addresses &&
//     !!Object.keys(userContext.my.addresses)[1] ? (
//       Object.keys(userContext.my.addresses)
//         .filter((addressId, i) => i === 1)
//         .map(addressId => userContext.my.addresses[addressId])
//         .map((address, i) => (
//           <ProfileFormAddressCard
//             userContext={userContext}
//             index={2}
//             address={address}
//             key={`address-card-${2}`}
//           />
//         ))
//     ) : (
//       <ProfileFormAddressAdd
//         key={`add-address-card-${2}`}
//         title={`Add Address #${2}`}
//         userContext={userContext}
//       />
//     )
//   }
// }



// WEBPACK FOOTER //
// ./src/components/profileFormAddresses/ProfileFormAddresses.js